/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetStatusUsageRequest = { path?: string | undefined };

export const GetStatusUsageRequest$zodSchema: z.ZodType<GetStatusUsageRequest> =
  z.object({
    path: z.string().describe(
      "（可选）如果你想查询某个特定的端点，请提供它的路径，例如 '/api/v1/image/motou'。如果留空，则返回所有端点的统计列表。",
    ).optional(),
  });

/**
 * 未找到
 */
export type GetStatusUsageNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetStatusUsageNotFoundResponseBody$zodSchema: z.ZodType<
  GetStatusUsageNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("未找到");

/**
 * 查询指定path参数时返回的单个端点统计数据
 */
export type GetStatusUsage2 = {
  path?: string | undefined;
  count?: number | undefined;
};

export const GetStatusUsage2$zodSchema: z.ZodType<GetStatusUsage2> = z.object({
  count: z.int().optional(),
  path: z.string().optional(),
}).describe("查询指定path参数时返回的单个端点统计数据");

export type Endpoint = {
  path?: string | undefined;
  count?: number | undefined;
};

export const Endpoint$zodSchema: z.ZodType<Endpoint> = z.object({
  count: z.int().optional(),
  path: z.string().optional(),
});

export type Unaggregated = {
  count?: number | undefined;
  oldest_log?: string | undefined;
};

export const Unaggregated$zodSchema: z.ZodType<Unaggregated> = z.object({
  count: z.int().optional(),
  oldest_log: z.string().optional(),
});

/**
 * 查询所有端点时返回的聚合统计数据
 */
export type GetStatusUsage1 = {
  endpoints?: Array<Endpoint> | undefined;
  unaggregated?: Unaggregated | undefined;
};

export const GetStatusUsage1$zodSchema: z.ZodType<GetStatusUsage1> = z.object({
  endpoints: z.array(z.lazy(() => Endpoint$zodSchema)).optional(),
  unaggregated: z.lazy(() => Unaggregated$zodSchema).optional(),
}).describe("查询所有端点时返回的聚合统计数据");

/**
 * 查询某条路径时
 */
export type GetStatusUsageResponseBody = GetStatusUsage1 | GetStatusUsage2;

export const GetStatusUsageResponseBody$zodSchema: z.ZodType<
  GetStatusUsageResponseBody
> = z.union([
  z.lazy(() => GetStatusUsage1$zodSchema),
  z.lazy(() => GetStatusUsage2$zodSchema),
]).describe("查询某条路径时");

export type GetStatusUsageResponse =
  | GetStatusUsage1
  | GetStatusUsage2
  | GetStatusUsageNotFoundResponseBody;

export const GetStatusUsageResponse$zodSchema: z.ZodType<
  GetStatusUsageResponse
> = z.union([
  z.union([
    z.lazy(() => GetStatusUsage1$zodSchema),
    z.lazy(() => GetStatusUsage2$zodSchema),
  ]),
  z.lazy(() => GetStatusUsageNotFoundResponseBody$zodSchema),
]);
